import { value } from '@takeshape/util';
import { CURRENT_OPEN_API_TRANSFORM_VERSION } from "../constants.js";
import { updateAuthentication } from "../util/authentication.js";
import { hasEveryKey } from "../util/has.js";
import { endpointWithPath, getHealthCheck } from "../util/health.js";
const title = 'Gorgias';
const serviceProvider = {
    name: 'gorgias',
    title,
    description: 'Gorgias ecommerce helpdesk',
    categories: ['ecommerce', 'helpdesk'],
    links: [{ title: 'Homepage', url: 'https://www.gorgias.com/' }],
    serviceType: 'openapi',
    introspectionType: 'openapi',
    createId: value('gorgias'),
    getFormSchema: value({
        type: 'object',
        properties: {
            id: {
                title: 'Slug',
                type: 'string',
                pattern: '^[0-9a-z_-]+$',
                default: 'gorgias'
            },
            title: {
                title: 'Name',
                type: 'string',
                default: title
            },
            namespace: {
                title: 'Namespace',
                type: 'string',
                pattern: '^[A-Z][A-Za-z]+$',
                default: title
            },
            endpoint: {
                title: 'Base API URL',
                type: 'string',
                format: 'url'
            },
            authentication: {
                title: 'Authentication',
                description: 'The following properties are encrypted and are obscured on this form to ensure the security of your data.',
                type: 'object',
                properties: {
                    username: {
                        title: 'Email',
                        type: 'string',
                        '@sensitive': true
                    },
                    password: {
                        title: 'API Key',
                        type: 'string',
                        '@sensitive': true
                    }
                },
                required: ['username', 'password']
            }
        },
        required: ['title', 'id', 'namespace', 'endpoint', 'authentication']
    }),
    getFormConfig: value({
        order: ['title', 'id', 'namespace', 'endpoint', 'authentication'],
        properties: {
            title: {
                widget: 'singleLineText',
                instructions: 'A human-readable title for this service.'
            },
            id: {
                widget: 'singleLineText',
                instructions: 'A unique, url-safe identifier for this service.'
            },
            namespace: {
                widget: 'singleLineText',
                instructions: 'A namespace to use for any generated types or queries. For example, if you enter `Foo` your types will be named `Foo_Bar`.'
            },
            endpoint: {
                widget: 'singleLineText',
                instructions: 'Your base API URL found at https://your-account.gorgias.com/app/settings/api'
            },
            authentication: {
                order: ['username', 'password'],
                properties: {
                    username: {
                        instructions: 'Your email address found at https://your-account.gorgias.com/app/settings/api',
                        widget: 'sensitiveField'
                    },
                    password: {
                        instructions: 'Your api key found at https://your-account.gorgias.com/app/settings/api',
                        widget: 'sensitiveField'
                    }
                }
            }
        }
    }),
    getConfig(formData) {
        const config = {
            title: formData.title ?? title,
            namespace: formData.namespace ?? title,
            provider: 'gorgias',
            serviceType: 'openapi',
            authenticationType: 'basic',
            options: {
                endpoint: formData.endpoint,
                spec: 'https://raw.githubusercontent.com/takeshape/openapi-specs/d1868f3d59e80841e4c9c4390129fcdb698811b7/specs/gorgias/v1.yml',
                transformVersion: CURRENT_OPEN_API_TRANSFORM_VERSION,
                useRestfulNames: true,
                disableEnums: true
            }
        };
        return updateAuthentication(config, formData, { type: 'basic' });
    },
    isCompleteConfig: hasEveryKey(['authentication', 'options.endpoint', 'options.spec']),
    getHealthCheck: getHealthCheck({
        checkName: 'ping',
        endpoint: endpointWithPath('/customers')
    })
};
export default serviceProvider;
